<template>
  <div>
    <section v-if="isLeft" class="hand">

      <h4 class="hand-tittle">Mão Esquerda</h4>

      <div class="finger-box">
        <img class="base-image" alt="left hand image"
             src="../../../static/img/fingers/left-hand.svg"/>
        <img v-if="LeftThumb" id="left-thumb" alt="left thumb finger"
             src="../../../static/img/fingers/left-thumb.svg"/>
        <img v-if="LeftIndexFinger" id="left-index" alt="left index finger"
             src="../../../static/img/fingers/left-index.svg"/>
        <img v-if="LeftMiddleFinger" id="left-middle" alt="left middle finger"
             src="../../../static/img/fingers/left-middle.svg"/>
        <img v-if="LeftRingFinger" id="left-ring" alt="left ring finger"
             src="../../../static/img/fingers/left-ring.svg"/>
        <img v-if="LeftLittleFinger" id="left-little" alt="left little finger"
             src="../../../static/img/fingers/left-little.svg"/>
      </div>
    </section>

    <section v-if="isRight" class="hand">

      <h4 class="hand-tittle">Mão Direita</h4>

      <div class="finger-box">
        <img class="base-image" alt="right hand image" src="../../../static/img/fingers/right-hand.svg"/>

        <img v-if="RightThumb" id="right-thumb" alt="right thumb finger"
             src="../../../static/img/fingers/left-thumb.svg"/>
        <img v-if="RightIndexFinger" id="right-index" alt="right index finger"
             src="../../../static/img/fingers/left-index.svg"/>
        <img v-if="RightMiddleFinger" id="right-middle" alt="right middle finger"
             src="../../../static/img/fingers/left-middle.svg"/>
        <img v-if="RightRingFinger" id="right-ring" alt="right ring finger"
             src="../../../static/img/fingers/left-ring.svg"/>
        <img v-if="RightLittleFinger" id="right-little" alt="right little finger"
             src="../../../static/img/fingers/left-little.svg"/>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'HandFrame',
  props: {
    isLeft: false,
    LeftThumb: Boolean,
    LeftIndexFinger: Boolean,
    LeftMiddleFinger: Boolean,
    LeftRingFinger: Boolean,
    LeftLittleFinger: Boolean,
    isRight: false,
    RightThumb: Boolean,
    RightIndexFinger: Boolean,
    RightMiddleFinger: Boolean,
    RightRingFinger: Boolean,
    RightLittleFinger: Boolean
  }
}
</script>

<style scoped>
.hand {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 2rem 0;
}

.finger-box {
  position: relative;
  display: inline-block;
  max-width: 118px;
}

.base-image {
  position: relative;
}

.hand-tittle {
  font: var(--font-style-normal) normal var(--font-weight-bold) 25px/var(--line-spacing-35) var(--font-family-poppins);
  letter-spacing: var(--character-spacing-0);
  text-align: left;
  color: #494F54;
}

#left-thumb {
  position: absolute;
  top: 51px;
  right: -16px;
}

#left-index {
  position: absolute;
  top: 0;
  right: 17px;
}

#left-middle {
  position: absolute;
  top: -6px;
  right: 48px;
}

#left-ring {
  position: absolute;
  top: 0;
  right: 72px;
}

#left-little {
  position: absolute;
  top: 10px;
  right: 95px;
}

#right-thumb {
  position: absolute;
  top: 51px;
  right: 90px;
  transform: scaleX(-1);
}

#right-index {
  position: absolute;
  top: 0;
  right: 70px;
  transform: scaleX(-1);
}

#right-middle {
  position: absolute;
  top: -6px;
  right: 46px;
  transform: scaleX(-1);
}

#right-ring {
  position: absolute;
  top: 0;
  right: 22px;
  transform: scaleX(-1);
}

#right-little {
  position: absolute;
  top: 10px;
  right: -12px;
  transform: scaleX(-1);
}
</style>



// WEBPACK FOOTER //
// HandFrame.vue?0092302b